import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';
import { DayType } from '../DayType';

type PickerCondensedDayProps = {
  isLegend?: boolean;
  dayType: DayType;
  isSelected?: boolean;
};

export const PickerCondensedDay = styled(Grid)<PickerCondensedDayProps>(({ theme, isLegend, dayType, isSelected }) => ({
  width: isLegend ? '20px' : '70px',
  height: isLegend ? '20px' : '30px',
  borderRadius: '4px',
  gap: '4px',
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  border: isSelected ? `2px solid ${theme.customTheme.palette.border}` : undefined,
  color: theme.customTheme.palette.text.primary,
  textDecoration: dayType === 'fullyBookedDay' ? 'line-through' : undefined,
  background: isSelected
    ? theme.customTheme.palette.calendarPicker[dayType]?.selected
    : theme.customTheme.palette.calendarPicker[dayType]?.background,
  '&:hover': {
    background: isLegend
      ? theme.customTheme.palette.calendarPicker[dayType]?.background
      : theme.customTheme.palette.calendarPicker[dayType]?.hover,
    cursor: isLegend ? 'cursor' : 'pointer',
  },
}));
